module.exports = __webpack_public_path__ + "static/anne-squat-02-4d4f5b80130f5f75f72c46af1d696cf8.jpg";